import React from 'react';

const Founder = () => {
  return (
    <section className="relative min-h-[60vh] md:min-h-[70vh] flex flex-col">
      {/* Subtle overlay for readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-navy-900/50 via-navy-900/30 to-navy-900/60" />

      {/* Content */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center text-center pt-12 md:pt-16 px-6">
        <h2
          className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-cream-100 tracking-[0.08em] mb-2"
          data-aos="fade-down"
        >
          BENTLEY G.S. BRAR
        </h2>
        <p className="font-serif text-base md:text-lg lg:text-xl text-cream-200/70 italic mb-6">
          (Gurparm Singh Bentley Brar)
        </p>
        <div className="gold-divider w-48 md:w-64 mb-8 md:mb-12" />

        {/* LinkedIn Icon */}
        <a
          href="https://ca.linkedin.com/in/bentleygurparmbrar"
          target="_blank"
          rel="noreferrer"
          className="group transition-transform duration-300 hover:scale-105"
          aria-label="LinkedIn Profile"
          data-aos="zoom-in"
          data-aos-delay="200"
        >
          <div className="w-20 h-20 md:w-24 md:h-24 bg-[#0077B5] rounded-xl shadow-xl flex items-center justify-center group-hover:shadow-2xl transition-shadow duration-300">
            <svg
              className="w-12 h-12 md:w-14 md:h-14 text-white"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
          </div>
        </a>
      </div>
    </section>
  );
};

export default Founder;
